import MyManualsModulePage from './my-manuals/MyManualsModulePage';

export default MyManualsModulePage;
